<template>
  <div class="hse">
    <van-nav-bar title="数据共计：2543份" class="custom-nav-bar" />
    <div class="search-container">
      <van-search
        class="custom-search"
        v-model="searchValue"
        placeholder="模糊搜索，请输入关键词"
        @search="onSearch"
      />
      <van-button type="primary" class="search-btn" @click="onSearch">查询</van-button>
    </div>

    <div class="data-list">
      <div v-for="(item, index) in dataList" :key="index" class="data-item">
        <div class="data-header">
          <span class="data-title">数据{{ index + 1 }}：</span>
          <div class="share-btn" @click="onShare(item)">
            <img src="../../assets/share.png" alt="分享" />
            <span>分享</span>
          </div>
        </div>
        <div class="data-content">
          <div class="data-row">
            <span class="label">姓名</span>
            <span class="value">{{ item.name }}</span>
          </div>
          <div class="data-row">
            <span class="label">身份证</span>
            <span class="value">{{ item.idCard }}</span>
          </div>
          <div class="data-row">
            <span class="label">单位</span>
            <span class="value">{{ item.organization }}</span>
          </div>
          <div class="data-row">
            <span class="label">部门</span>
            <span class="value">{{ item.department }}</span>
          </div>
          <div class="data-row">
            <span class="label">证号</span>
            <span class="value">{{ item.certificateNo }}</span>
          </div>
          <div class="data-row">
            <span class="label">发证日期</span>
            <span class="value">{{ item.issueDate }}</span>
          </div>
          <div class="data-row">
            <span class="label">截止日期</span>
            <span class="value">{{ item.expiryDate }}</span>
          </div>
          <div class="data-row">
            <span class="label">类型</span>
            <span class="value">{{ item.certType }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import Vue from "vue";
import {
  NavBar,
  Image as VanImage,
  Cell,
  CellGroup,
  Search,
  Icon,
  Button,
} from "vant";
Vue.use(NavBar);
Vue.use(VanImage);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Search);
Vue.use(Icon);
Vue.use(Button);
import { listYtcert } from "../../services/api/index";
import util from "../../utils";
export default {
  data() {
    return {
      id: "",
      info: {},
      host: process.env.VUE_APP_BASE_API,
      searchValue: "",
      idCard: "",
      certificateNo: "",
      pageNum: 1,
      pageSize: 10,
      dataList: [],
    };
  },
  created() {
    this.certificateNo = util.getUrlParamByName("certificateNumber");
    this.idCard = util.getUrlParamByName("idCard");
    this.id = util.getUrlParamByName("id");
    this.init();
  },
  methods: {
    async init() {
      //
      const params = {
        name: this.searchValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      if (this.idCard) {
        params.idCard = this.idCard;
      }
      if (this.certificateNo) {
        params.certificateNo = this.certificateNo;
      }
      if (this.id) {
        params.id = this.id;
      }
      if (this.searchValue) {
        params.searchValue = this.searchValue;
      }
      let res = await listYtcert(params);
      if (res) {
        this.dataList = res.rows;
      }
    },
    goBack() {
      history.back();
    },
    onSearch() {
      this.pageNum = 1;
      this.init();
      // 在这里实现搜索逻辑
    },
    onShare(item) {
      console.log("分享数据:", item);
      // 在这里实现分享逻辑
    },
  },
};
</script>
    
  <style lang="scss">
.hse {
  // height: 100%;
  // background-color: #f7f8fa;
  margin: 0;
  padding: 0;
  padding-bottom: 120px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  .custom-nav-bar {
    background: linear-gradient(90deg, #4e8ef7, #5ae0c9) !important;
    .van-nav-bar__title {
      color: white !important;
    }
    .van-icon {
      color: white !important;
    }
  }

  .search-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    background-color: #fff;
    border-bottom: 1px solid #eee;
  }
  .custom-search {
    background-color: #f5f5f5;
    border-radius: 50px;
    padding: 0 !important;
    margin: 8px !important;
    flex: 1;
  }

  .custom-search .van-search__content {
    background-color: transparent;
    border-radius: 50px;
  }

  .custom-search .van-search__input {
    border: none;
    background-color: transparent;
  }

  .search-btn {
    width: 60px;
    height: 32px;
    border: none !important;
    background-color: #5ae0c9;
  }

  .data-list {
    padding: 10px 0;
    margin-bottom: 120px;
  }

  .data-item {
    background-color: #fff;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 15px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .data-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }

  .data-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    display: flex;
    align-items: center;
  }
  .data-title:before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #ff6b00;
    margin-right: 8px;
  }

  .share-icon {
    color: #1989fa;
    font-size: 13px;
  }

  .share-btn {
    display: flex;
    align-items: center;
    color: #1989fa;
    cursor: pointer;
    font-size: 14px;
  }

  .share-btn img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .data-content {
    font-size: 14px;
    color: #666;
  }

  .data-row {
    display: flex;
    margin-bottom: 10px;
  }

  .label {
    width: 80px;
    font-weight: bold;
    color: #666;
  }

  .value {
    flex: 1;
    color: #333;
  }
}
</style>
    